module.exports = __webpack_public_path__ + "static/media/seven-signs-you-should-look-for-a-new-job.477795b6.md";